import { useTranslation } from 'react-i18next';
import MiniBetslip from '@cx-web/feature-betslip/components/components/mini-betslip';
import { trackingActions } from '@cx-web/feature-tracking';

import styles from '../../MobileBottomNav.module.css';
import { handleEvent } from '../../utils/handleEvent';

export const BetslipToggle = () => {
  const { t } = useTranslation(['label']);
  const betslipText = t('CX_BETSLIP');

  return (
    <li className={`${styles.menuItem}`} onClick={() => handleEvent(betslipText, trackingActions)}>
      <span className={styles.iconContainer}>
        <MiniBetslip betslipTitle={betslipText} />
      </span>
      {betslipText}
    </li>
  );
};
